import {Component, OnDestroy, OnInit, OnChanges} from '@angular/core';
import {PersonService} from "../../services/person/person-service";
import {CompanyService} from "../../services/company-service/company-service";
import {CompanyCustomFormVM} from "../../models/CompanyCustomFormVM.model";
import {AuthService} from "../../services/auth/AuthService";
import {CompanyCustomerVM} from "../../models/CompanyCustomerVM.model";
import {API_URL_GET_COMPANY_CUSTOMER_BY_USER_ID_AND_COMPANY_ID} from "../../services/constants";
import {AlertService} from "../../services/alert/alert.service";


@Component({
  selector: 'rw-complementary-information',
  template: require('./complementaryInformation.component.html'),
  styles: [require('./complementaryInformation.style.css')],
  providers: [PersonService]

})

export class ComplementaryInformationComponent implements OnDestroy, OnInit {

  companyCustomer: CompanyCustomerVM;
  companyId: number;
  companyCustomFormList: CompanyCustomFormVM[];

  constructor(private personService: PersonService,
              private companyService: CompanyService,
              private authService: AuthService,
              private alertService: AlertService) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.companyService.getCompanyInfo().subscribe((company) => {
      this.personService.getCompanyCustomerByUserIdAndCompanyId(this.authService.currentUser.id, company.id).subscribe(res => {
        this.companyCustomer = res;

        this.companyService.getCompanyCustomFormById(res.companyId).subscribe(cf => {
          this.companyCustomFormList = cf;
          this.companyId = res.companyId;
        })
      });
    });
  }

  save() {
    this.companyService.saveCompanyCustomer(this.companyCustomer).subscribe(res => {
      // console.log('user saved: ' + res);
      this.alertService.showSuccessMessage('global.messages.info.informationSavedSuccessfully');
    })
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/complementary-information/complementaryInformation.component.ts